import { NgModule } from '@angular/core';
import { VldGroupDirective } from 'directives/vld-group/vld-group';
import { VldButtonDirective } from 'directives/vld-button/vld-button';
import { VldProgressDirective } from 'directives/vld-progress/vld-progress';
import { VldButtonSkipDirective } from './vld-button-skip/vld-button-skip';
import { RadioGroupDirective } from './radio-group/cs-radio-group-directive';
import { UntranslatedPipe } from './untranslated/untranslated.pipe';
@NgModule({
  declarations: [
    VldGroupDirective,
    VldButtonDirective,
    VldProgressDirective,
    VldButtonSkipDirective,
    RadioGroupDirective,
    UntranslatedPipe,
  ],
  imports: [],
  exports: [
    VldGroupDirective,
    VldButtonDirective,
    VldProgressDirective,
    VldButtonSkipDirective,
    RadioGroupDirective,
    UntranslatedPipe,
  ],
})
export class DirectivesModule {
  constructor() {}
}
